export const showSignedIn = (isLoggedIn, showIfLoggedIn) => {
  return ((isLoggedIn && showIfLoggedIn) || !showIfLoggedIn);
}